import * as React from 'react';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import SelectField from '../../common/form-controls/SelectField';
import { AWSPortOpeningRequestsTypes } from '../../../models/enums/POR/AWSPortOpeningRequestType';


interface PORTypeInputProps {
    scope: FieldHandler<string>;
}

const AWSPORTypeInput = ({ scope }: PORTypeInputProps ) => {

    const typeOptions = () => {
        return [
            { value: AWSPortOpeningRequestsTypes.AccountToInternet.name, text: AWSPortOpeningRequestsTypes.AccountToInternet.displayName },
            { value: AWSPortOpeningRequestsTypes.AccountToDMZ.name, text: AWSPortOpeningRequestsTypes.AccountToDMZ.displayName },
            { value: AWSPortOpeningRequestsTypes.Untrusted.name, text: AWSPortOpeningRequestsTypes.Untrusted.displayName }
        ];
    };

    return (
        <SelectField
            label="Type"
            className="full-width"
            options={typeOptions()}
            {...scope}
        />
    );
}

export default AWSPORTypeInput;